import React, { useMemo } from 'react';
import styled from "styled-components";
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { SpaceBetweenRow } from '@features/settings/pages/StyleComponents';
import Colours from '@shared/ui/atoms/Colours';
import { useSelector } from "react-redux";
import { CustomLeaveDays } from '@features/holidays/services/HolidayService';
import { selectAllWhereaboutsOptions } from '@features/whereabouts/store/whereaboutsOptions.duck';
import { iconPackPath } from '@shared/utils/WhereaboutsHelper';
import { FreeBusyStatus } from '@features/whereabouts/services/WhereaboutOptions';
import { selectIconPack } from '@shared/store/auth.duck';
import { SideOfDay } from '@features/whereabouts/models/movements.models';
import Icon, { IconTypes } from '@shared/ui/atoms/icon/Icon';
import { PopupPosition } from "./HolidayInfoAndApprovalPopup";
import { HolidayPopupShell } from "./HolidayPopupShell";

export function CustomLeaveInfoPopup(props: Props) {
  const {customLeaveDay} = props;
  const customLeaveList = useSelector(selectAllWhereaboutsOptions);
  const iconPack = useSelector(selectIconPack);

  const amCustomLeave = useMemo(() => {
    return customLeaveList.find(cl => cl.id === customLeaveDay.amWhereaboutsId)
  }, [customLeaveDay.amWhereaboutsId, customLeaveList]);

  const pmCustomLeave = useMemo(() => {
    return customLeaveList.find(cl => cl.id === customLeaveDay.pmWhereaboutsId)
  }, [customLeaveDay.pmWhereaboutsId, customLeaveList]);

  const customLeaveForSideOfDay = useMemo(() => {
    if (props.sideOfDay === SideOfDay.AM || props.sideOfDay === SideOfDay.AllDay) {
      return amCustomLeave
    } else {
      return pmCustomLeave
    }
  }, [amCustomLeave, pmCustomLeave, props.sideOfDay]);

  if (!amCustomLeave || !pmCustomLeave || !customLeaveForSideOfDay) {
    return null;
  }

  if (props.showBothSidesOfDayIfDifferent && customLeaveDay.amWhereaboutsId !== customLeaveDay.pmWhereaboutsId) {
    return (
      <HolidayPopupShell isVisible={props.isVisible}
                         triggerRect={props.triggerRect}
                         popupPositioning={props.popupPositioning}
                         onMouseEnter={props.onMouseEnter}
                         onMouseLeave={props.onMouseLeave}>
        <SpaceBetweenRow style={{alignItems: 'center', marginBottom: 4}}>
          <BodyRegular colour={Colours.darkGreen} weight={600}>Custom Leave</BodyRegular>
          <Icon icon={IconTypes.Calendar} />
        </SpaceBetweenRow>

        <BodyRegular style={{marginBottom: 2}}><strong>AM:</strong> {amCustomLeave.label}</BodyRegular>
        <BodyRegular style={{marginBottom: 2}}><strong>PM:</strong> {pmCustomLeave.label}</BodyRegular>
      </HolidayPopupShell>
    )
  } else {
    return (
      <HolidayPopupShell isVisible={props.isVisible}
                         triggerRect={props.triggerRect}
                         popupPositioning={props.popupPositioning}
                         onMouseEnter={props.onMouseEnter}
                         onMouseLeave={props.onMouseLeave}>
        <SpaceBetweenRow style={{alignItems: 'center', marginBottom: 4}}>
          <BodyRegular colour={Colours.darkGreen} weight={600}>Custom Leave</BodyRegular>
          <LeaveImage src={iconPackPath(iconPack, customLeaveForSideOfDay.image, FreeBusyStatus.FREE)} alt={""} />
        </SpaceBetweenRow>

        <BodyRegular style={{marginBottom: 2}} weight={600}>{customLeaveForSideOfDay.label}</BodyRegular>
      </HolidayPopupShell>
    )
  }
}

interface Props {
  customLeaveDay: CustomLeaveDays;
  popupPositioning?: PopupPosition;
  sideOfDay: SideOfDay;
  showBothSidesOfDayIfDifferent?: boolean;
  isVisible: boolean;
  triggerRect?: DOMRect;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const LeaveImage = styled.img`
  max-width: 40px;
  max-height: 40px;
`
